import React, { useContext } from "react"

export const UserContext = React.createContext()

export const useUser = () => {
    return useContext( UserContext )
}